import { useAuth } from "./hooks/useAuth";
import { usePath } from "./lib/router";
import LoginPage from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import MainLeave from "./pages/MainLeave";
import ApiTest from "./pages/ApiTest";
import DbViewer from "./pages/DbViewer";
import LeaveRequestPage from "./pages/LeaveRequest";
import LeaveListPage from "./pages/LeaveList";
import LeaveDetail from "./pages/LeaveDetail";
import LeaveCalendar from "./pages/LeaveCalendar";
import AdminPanel from "./pages/AdminPanel";
import LeaveBalanceManagement from "./pages/LeaveBalanceManagement";
import UserApproval from "./pages/UserApproval";
import EditLeaveRequestPage from "./pages/EditLeaveRequest";
import WfhAttendancePage from "./pages/WfhAttendance";
import AttendanceManagementPage from "./pages/AttendanceManagement";

function App() {
  // Simple routing based on URL path
  const path = usePath();

  // Public routes - don't call useAuth to avoid unnecessary API calls
  // API Test page (for debugging)
  if (path === "/api-test") {
    return <ApiTest />;
  }

  // Database Viewer (for debugging)
  if (path === "/db-viewer") {
    return <DbViewer />;
  }

  if (path === "/register") {
    return <Register />;
  }

  if (path === "/login") {
    return <LoginPage />;
  }

  // Protected routes - use auth hook
  const { user, isLoading } = useAuth();

  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-gray-600">กำลังโหลด...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    window.location.href = "/login";
    return null;
  }

  // Leave Request page (protected)
  if (path === "/leave/request" || path === "/leave/new") {
    return <LeaveRequestPage />;
  }

  // Leave List page (protected)
  if (path === "/leaves" || path === "/leave/list") {
    return <LeaveListPage />;
  }

  // Leave Calendar page (protected)
  if (path === "/calendar" || path === "/leave/calendar") {
    return <LeaveCalendar />;
  }

  // Leave Detail page (protected) - must come before other leave routes
  if (path.startsWith("/leaves/") && path !== "/leaves/") {
    // Check if it's an edit route
    if (path.includes("/edit")) {
      return <EditLeaveRequestPage />;
    }
    return <LeaveDetail />;
  }

  // Edit Leave Request page
  if (path.startsWith("/leave/edit/")) {
    return <EditLeaveRequestPage />;
  }

  // Admin Panel (admin only)
  if (path === "/admin" || path === "/admin/panel") {
    return <AdminPanel />;
  }

  // User Approval (admin/HR only)
  if (path === "/admin/user-approval" || path === "/user-approval") {
    return <UserApproval />;
  }

  // Leave Balance Management (admin/HR only)
  if (path === "/leave-balances" || path === "/admin/leave-balances") {
    return <LeaveBalanceManagement />;
  }

  if (path === "/attendance/wfh") {
    return <WfhAttendancePage />;
  }

  if (path === "/attendance/manage") {
    return <AttendanceManagementPage />;
  }

  // Main Leave page (default authenticated route)
  if (path === "/") {
    return <MainLeave />;
  }

  // Dashboard page (can be different from main leave page)
  if (path === "/dashboard") {
    return <Dashboard />;
  }

  // Default: show main leave page
  return <MainLeave />;
}

export default App;
